export const TABS = [
  { id: "applications", label: "Student Applications" },
  { id: "school-inquiries", label: "School Inquiries" },
  { id: "brand-inquiries", label: "Brand + Sponsor" },
];

export const STATUSES = {
  "applications": ["new", "reviewing", "interview_requested", "waitlisted", "accepted", "declined", "onboarding", "onboarded", "inactive"],
  "school-inquiries": ["new", "contacted", "meeting_scheduled", "partnership_pending", "active_partner", "inactive"],
  "brand-inquiries": ["new", "qualified", "meeting_scheduled", "proposal", "agreement", "active_partner", "completed", "returning_partner", "declined"],
};

export const CONFIRM_STATUSES = ["accepted", "declined", "active_partner", "inactive"];

export const RATINGS = [
  { key: "creative_potential", label: "Creative Potential" },
  { key: "collaboration_fit", label: "Collaboration Fit" },
  { key: "reliability_availability", label: "Reliability / Availability" },
  { key: "growth_opportunity", label: "Growth Opportunity" },
  { key: "cohort_need", label: "Cohort Need" },
];

export const FLAGS = ["Strong portfolio", "Strong concept thinking", "Leadership potential", "Beginner / high potential", "Cross-disciplinary fit", "Needs portfolio development", "Scheduling concern", "Transportation concern", "Equipment / software concern", "School-credit coordination", "Consider paid opportunities", "Consider future cohort"];

export const SCHOOL_FIELDS = [
  { key: "program_fit", label: "Program fit" }, { key: "partnership_type", label: "Partnership type" },
  { key: "next_action", label: "Next action" }, { key: "meeting_date", label: "Meeting date" },
  { key: "requirements", label: "Requirements" }, { key: "contact", label: "Contact" },
];

export const BRAND_FIELDS = [
  { key: "opportunity_quality", label: "Opportunity quality" }, { key: "budget_fit", label: "Budget fit" },
  { key: "creative_fit", label: "Creative fit" }, { key: "student_benefit", label: "Student benefit" },
  { key: "commercial_usage", label: "Commercial usage" }, { key: "compensation_required", label: "Compensation required" },
];

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

const STATUS_COLORS = {
  new: "border-gold/60 bg-gold/10 text-goldlight",
  reviewing: "border-silver/50 bg-silver/10 text-silver",
  accepted: "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]",
  onboarding: "border-[#3ad07a]/40 bg-[#3ad07a]/5 text-[#7fe0a8]",
  onboarded: "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]",
  active_partner: "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]",
  declined: "border-silver/30 text-silver/50",
  inactive: "border-silver/30 text-silver/50",
};
export const statusCls = (s) => STATUS_COLORS[s] || "border-silver/40 text-silver";

export const inputCls = "border border-silver/30 bg-onyx px-3 py-2.5 font-body text-sm font-medium text-cream outline-none focus:border-gold placeholder:text-silver/40";
export const cardCls = "border border-gold/25 bg-charcoal";
export const goldBtnCls = "btn-sweep border border-gold bg-gradient-to-b from-goldlight to-gold font-head font-extrabold uppercase tracking-wide text-onyx transition-transform hover:-translate-y-0.5 disabled:opacity-60";
export const ghostBtnCls = "border border-silver/30 bg-charcoal font-head font-extrabold uppercase tracking-wide text-silver transition-colors hover:border-gold hover:text-goldlight disabled:opacity-60";
